<i18n>
{
    "ar": {

        "sections": {
            "1": {
                "title": "دراسة تكنولوجي | Derasa Tech",
                "subtitle": "ابدأ الآن منصتك التعليمية مع دراسة تكنولوجي",
                "subtitle2": "نظام تعلم إلكتروني آمن ومُتطور"
            },
            "about": {
                "title": "معلومات عن الشركة",
                "subtitle": "معلومات وتفاصيل عن الشركة وآلية عملها وأهدافها",
                "row1": {
                    "title": "من نحن؟ وماذا نفعل؟ وما هي أهدافنا ؟",
                    "content": "EBMSoft هي شركة تطوير برمجيات وحلول تقنية تطوّر وتمتلك عدة أنظمة ومشاريع متقدمة تهدف إلى دعم وتطوير اﻷعمال التجارية اﻹلكترونية وتسهيل آلية عملها وإحداث طفرة في أسلوب استخدام اﻷعمال التجارية للتكنولوجيا الحديثة كما تقدم الشركة خدمات ومنصات تساعد وتحل مشاكل العاملين بأي صناعة من صناعات اﻷعمال اﻹلكترونية في الشرق اﻷوسط والوطن العربي."
                },
                "row2": {
                    "title": "نطور برمجيات وأنظمة مخصصة ومتطورة!",
                    "content": "يستخدم فريق عمل شركة EBMSoft أحدث تقنيات البرمجة والتصميم لتطوير المواقع واﻷنظمة وتطبيقات Android  و IOS وكذلك برامج الحاسوب مما يمكننا من تنفيذ اﻷفكار واﻹبتكارات بشكل مخصص وإطلاق منصات حديثة، سريعة، وقوية تشمل مميزات غير مسبوقة باﻷنظمة اﻷخرى في الشرق اﻷوسط والوطن العربي!"
                }
            },
            "features": {
                "title": "المميزات الرئيسية",
                "subtitle": "المميزات الأساسية في نظام دراسة تكنولوجي",
                "items": [
                    "نظام حماية قوي لتأمين الفيديوهات من السرقة",
                    "نظام بنوك أسئلة وامتحانات متقدم",
                    "دعم أسئلة الاختيار من متعدد كتابة أو صور",
                    "نظام تصحيح آلي لإجابات الامتحانات",
                    "نظام مستقرّ تقنياً",
                    "نظام بطاقات الدفع (الدفع بالأكواد)",
                    "نظام محفظة المستخدم",
                    "علامة مائية على الفيديوهات",
                    "مركز إشعارات متكامل",
                    "مركز دعم لاستقبال مشكلات الطلاب",
                    "لوحة معلم منفصلة لإدارة دوراته وتلقي تقاريره",
                    "لوحة تحكم متقدمة وسريعة وسهلة الاستخدام",
                    "دعم فيديوهات يوتيوب وفيميو"
                ]
            },
            "stats": {
                "title": "إحصائيات وأرقام",
                "subtitle": "بعض الإحصائيات والأرقام الهامة لدراسة تكنولوجي",
                "items": [
                    {"label": "عدد الطلاب مستخدمي النظام", "value": "stats_total_users", "icon": "mdi-account-group"},
                    {"label": "عدد المحاضرات المضافة", "value": "stats_total_lectures", "icon": "mdi-play-box-multiple-outline"},
                    {"label": "عدد مشاهدات المحاضرات", "value": "stats_total_views", "icon": "mdi-eye-check-outline"}
                ]
            },
            "clients": {
                "title": "عملاؤنا",
                "subtitle": "بعض المنصات التعليمية التي بُنيت على نظام دراسة تكنولوجي",
                "items": [
                    {
                        "name": "mindshift",
                        "logo": "mindshift.svg",
                        "url": "https://academy.mb-mindshift.com",
                        "height": "36px"
                    },
                    {
                        "name": "oringtraining",
                        "logo": "oringtraining.svg",
                        "url": "https://academy.oringtraining.com",
                        "height": "40px"
                    },
                    {
                        "name": "fintechelearning",
                        "logo": "fintechelearning.png",
                        "url": "https://fintechelearning.com",
                        "height": "54px"
                    },
                    {
                        "name": "skillzonetraining",
                        "logo": "skillzonetraining.png",
                        "url": "https://skillzonetraining.com",
                        "height": "40px"
                    },
                    {
                        "name": "egyclasses",
                        "logo": "egyclasses.png",
                        "url": "https://www.egyclasses.com"
                    },
                    {
                        "name": "yallastep",
                        "logo": "yallastep.svg",
                        "url": "https://www.yallastep.com"
                    },
                    {
                        "name": "tri-sci",
                        "logo": "tri-sci.svg",
                        "url": "https://tri-sci.com"
                    },
                    {
                        "name": "drooosk",
                        "logo": "drooosk.svg",
                        "url": "https://drooosk.com",
                        "height": "40px"
                    },
                    {
                        "name": "teachtrick",
                        "logo": "teachtrick.svg",
                        "hidden": true,
                        "url": "https://teachtrick.co"
                    },
                    {
                        "name": "yallagerman",
                        "logo": "yallagerman.png",
                        "url": "https://yallagerman.com"
                    }
                ]
            },
            "partners": {
                "title": "شركاؤنا",
                "subtitle": "شُركاء دراسة تكنولوجي",
                "items": [
                    {
                        "name": "aws",
                        "height": 60,
                        "logo": "aws.png"
                    },
                    {
                        "name": "aws-s3",
                        "height": 60,
                        "logo": "aws-s3.png"
                    },
                    {
                        "name": "hetzner",
                        "height": 20,
                        "logo": "hetzner-logo.svg"
                    },
                    {
                        "name": "cloudflare",
                        "logo": "cloudflare.svg"
                    },
                    {
                        "name": "paymob",
                        "height": 40,
                        "logo": "paymob.png"
                    },
                    {
                        "name": "google-play",
                        "height": 40,
                        "logo": "google-play.svg"
                    },
                    {
                        "name": "appstore",
                        "logo": "appstore.png"
                    },
                    {
                        "name": "vimeo",
                        "logo": "vimeo.svg",
                        "height": 32
                    },
                    {
                        "name": "youtube",
                        "logo": "youtube.svg",
                        "height": 32
                    }
                ]
            },
            "contact": {
                "subtitle": "اترك لنا رسالة وسوف نقوم بالرد عليك بأسرع وقت ممكن"
            },
            "timeline": {
                "title": "الخط الزمني للشركة",
                "subtitle": "شريط زمني يضم الأحداث والتواريخ الهامة في تاريخ شركة EBMSoft"
            },
            "products": {
                "title": "مشاريعنا",
                "subtitle": "المنصات والخدمات اﻹلكترونية التابعة لشركتنا والتي نعمل على تطويرها وإدراتها"
            },
            "industries": {
                "title": "مجالات عملنا",
                "subtitle": "المجالات والصناعات التي نعمل حالياً على تطوير برمجيات متقدمة لدعمها وحل مشكلاتها",
                "cols": [
                    {
                        "headline": "التجارة اﻹلكترونية",
                        "description": "نعمل على تطوير وإدارة منصات تقدم حلولاً لمجال التجارة اﻹلكترونية والعاملين فيه مما يعطي قوة أكبر للبائع في الوصول للمشتري وكذلك للمشتري في الوصول لمنتج أفضل."
                    },
                    {
                        "headline": "التكنولوجيا المالية",
                        "description": "نعمل على تطوير منصات وبرمجيات وحلول لمجال التكنولوجيا المالية والتحويلات المالية الذي يواجه الكثير من المشاكل في الشرق اﻷوسط وتحديداً الوطن العربي."
                    },
                    {
                        "headline": "إدارة المشاريع",
                        "description": "نعمل على برمجة وتطوير برمجيات متطورة تساعد الشركات والمشاريع التجارية على اﻹدارة والمحاسبة بإستخدام التكنولوجيا الحديثة."
                    }
                ]
            },
            "actions": {
                "contact": "تواصل معنا",
                "about": "اعرف أكثر",
                "products": "مشاريعنا"
            }
        },
        "timeline": [
            {
                "title": "تأسيس شركة EBMSoft لتطوير البرمجيات",
                "content": "تأسيس شركة EBMSoft لتطوير البرمجيات والحلول التقنية واﻷنظمة التي تهدف إلى دعم وتطوير اﻷعمال التجارية اﻹلكترونية."
            },
            {
                "date": "قريباً",
                "title": "إطلاق أول نظام ومنصة تابعة للشركة",
                "content": "إطلاق أول نظام ومنصة تابعة لشركة EBMSoft في مجال التجارة اﻹلكترونية بهدف تقديم حلول أفضل وأكثر تطوراً وسهولةً وحل المشكلات الموجودة بالسوق حالياً."
            }
        ],
        
        "contact": {
            "subheader": "أو تواصل معنا عبر الوسائل اﻵتية:",
            "email": "البريد اﻹلكتروني",
            "facebook": "صفحة فيسبوك",
            "website": "موقع الويب"
        }
    },
    "en": {
    }
}
</i18n>
<template>
    <div class="page page-sections">
        <section id="headerSection" data-section="home" class="header-section fullpage-section">
            <v-container v-if="!loading" class="fill-height align-center pt-12">
                <v-slide-x-reverse-transition appear >
                    <div class="text-center" style="margin-bottom: 8rem">
                        <h1 class="strong-text--text">
                            {{$t('sections.1.title')}}
                        </h1>
                        <h2 class="text--text mt-5">
                            {{$t('sections.1.subtitle')}}
                        </h2>
                        <h2 class="text--text mt-5">
                            {{$t('sections.1.subtitle2')}}
                        </h2>
                        <div class="actions">
                            <!-- <v-btn @click="navigateToLink('#productsSection')" color="strong-text" :large="pcOnly" depressed outlined class="me-6">{{$t('sections.actions.products')}}</v-btn> -->
                            <v-btn @click="navigateToLink('#aboutSection')" color="strong-text" :large="pcOnly" depressed outlined class="me-6">
                                <v-icon left size="23">mdi-arrow-down-circle-outline</v-icon>
                                <span>{{$t('sections.actions.about')}}</span>
                            </v-btn>
                            <v-btn @click="navigateToLink('#contactSection')" color="amber" :large="pcOnly" outlined>
                                <v-icon left size="23">mdi-message-text-outline</v-icon>
                                <span>{{$t('sections.actions.contact')}}</span>
                            </v-btn>
                        </div>
                    </div>
                </v-slide-x-reverse-transition>
            </v-container>

            <div class="section-scroll-icon">
                <scroll-icon @click="scrollToSection(2)"/>
            </div>
        </section>
        <!-- <e-section id="aboutSection" data-section="about" :headline="$t('sections.about.title')" :subtitle="$t('sections.about.subtitle')" light divider>
            <v-row>
                <v-col :data-aos="pcOnly ? (isRtl ? 'fade-left' : 'fade-right') : 'fade-up'" data-aos-duration="800" :cols="pcOnly ? 5 : 12" class="">
                    <v-img src="/img/vector1.png" contain width="100%" max-height="320"></v-img>
                </v-col>
                <v-spacer></v-spacer>
                <v-col :data-aos="pcOnly ? (isRtl ? 'fade-right' : 'fade-left') : 'fade-up'" data-aos-duration="800" class="mt-6 mt-lg-0" :cols="pcOnly ? 6 : 12">
                    <h1 class="headline">{{$t('sections.about.row1.title')}}</h1>
                    <p class="medium-text text-light--text mt-6 mt-lg-8" :class="{'text-center': phoneOnly}">
                        {{$t('sections.about.row1.content')}}
                    </p>
                    <div class="actions">
                        <v-btn @click="navigateToLink('#industriesSection')" large depressed color="primary">{{$t('sections.industries.title')}}</v-btn>
                        <v-btn @click="navigateToLink('#timelineSection')" large depressed color="primary" outlined class="ms-lg-4 mt-3 mt-lg-0">{{$t('sections.timeline.title')}}</v-btn>
                    </div>
                </v-col>
            </v-row>
            <v-row style="margin-top: 3.5rem" class=" flex-row-reverse">

                <v-col :data-aos="pcOnly ? (isRtl ? 'fade-right' : 'fade-left') : 'fade-up'" data-aos-duration="800" :cols="pcOnly ? 5 : 12" class="">
                    <v-img src="/img/vector2.png" contain width="100%" max-height="320"></v-img>
                </v-col>
                <v-spacer></v-spacer>
                <v-col :data-aos="pcOnly ? (isRtl ? 'fade-left' : 'fade-right') : 'fade-up'" data-aos-duration="800" class="mt-6 mt-lg-0" :cols="pcOnly ? 6 : 12">
                    <h1 class="headline">{{$t('sections.about.row2.title')}}</h1>
                    <p class="medium-text text-light--text mt-6 mt-lg-8" :class="{'text-center': phoneOnly}">
                        {{$t('sections.about.row2.content')}}
                    </p>

                    <div class="actions">
                        <v-btn @click="navigateToLink('#productsSection')" large depressed color="primary">{{$t('sections.products.title')}}</v-btn>
                    </div>
                </v-col>
            </v-row>
        </e-section> -->
        
        <e-section id="featuresSection" data-section="features" :headline="$t('sections.features.title')" :subtitle="$t('sections.features.subtitle')" light divider>
            <v-row>
                <v-col cols="12" md="6" lg="4" v-for="(feature, i) in $t('sections.features.items')" :key="i" class="pa-0">
                    <v-list-item>
                        <v-list-item-icon>
                            <v-icon size="20" color="primary">mdi-circle-double</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title style="color: #000;">{{feature}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-col>
            </v-row>
        </e-section>

        <e-section id="statsSection" data-section="stats" :headline="$t('sections.stats.title')" :subtitle="$t('sections.stats.subtitle')" light divider dense>
            <v-row>
                <v-col v-for="(stat, i) in $t('sections.stats.items')" cols="12" lg="4" :key="i" class="d-flex justify-center">
                    <div class="d-flex align-center">
                        <v-avatar color="grey lighten-3" size="70" class="me-4">
                            <v-icon size="36" color="primary">{{stat.icon}}</v-icon>
                        </v-avatar>
                        <div>
                            <div>{{stat.label}}</div>
                            <h2>+
                                <span v-if="stats[stat.value]"><countup :value="stats[stat.value]"></countup></span>
                            </h2>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </e-section>


        <e-section id="clientsSection" data-section="clients" :headline="$t('sections.clients.title')" :subtitle="$t('sections.clients.subtitle')" light divider dense>
            <div class="clients-items" style="max-width: 900px">
                <div v-for="(client, i) in $t('sections.clients.items')" :key="i" class="mx-3 mx-lg-5 mb-6 client-logo">
                    <a target="_blank" :href="client.url">
                        <img :src="`/img/clients/${client.logo}`" :style="`height: ${client.height || '50px'}; max-height: ${client.height || '50px'}; width: auto; max-width: ${client.height ? 'unset' : '150px'};`" />
                    </a>
                </div>
            </div>
        </e-section>

        <e-section id="partnersSection" data-section="partners" :headline="$t('sections.partners.title')" :subtitle="$t('sections.partners.subtitle')" light divider dense>
            <div class="partners-items">
                <div v-for="(partner, i) in $t('sections.partners.items')" :key="i" class="mx-3 mx-lg-5 mb-6 partner-logo">
                    <img :src="`/img/partners/${partner.logo}`" :style="`min-height: ${partner.height || 50}px; max-height: ${partner.height || 50}px; width: auto; max-width: ${partner.height ? 'unset' : '150px'};`" />
                </div>
            </div>
        </e-section>

        
        <!-- <cols-section id="industriesSection" :headline="$t('sections.industries.title')" :subtitle="$t('sections.industries.subtitle')" :cols="industriesCols">

        </cols-section> -->

        <e-section v-if="false" id="timelineSection" data-section="timeline" divider :headline="$t('sections.timeline.title')" :subtitle="$t('sections.timeline.subtitle')" light>
            <timeline data-aos="fade-up" :data-aos-duration="800" :data="timeline" />
        </e-section>

        <e-section id="contactSection" data-section="contact" :headline="$t('links.contact')" :subtitle="$t('sections.contact.subtitle')" light>
            <v-row class="justify-center px-lg-12">
                <v-col :cols="pcOnly ? 6 : 12" class="ps-lg-12">
                    <contact-form data-once :data-aos="'fade'" :data-aos-duration="800" />
                </v-col>
                <v-col v-if="pcOnly" cols="1" class="text-center">
                    <v-divider vertical></v-divider>
                </v-col>
                <v-col :cols="pcOnly ? 3 : 12">
                    <div :data-aos="'fade'" :data-aos-duration="800">
                        <v-subheader>
                            {{$t('contact.subheader')}}
                        </v-subheader>
                        <v-list two-line>
                            <v-list-item v-for="item in contactItems" :key="item.name" :target="item.href ? '_blank' : ''" :href="item.href ? item.href : (item.name === 'email' ? `mailto:${item.value}` : '')">
                                <v-list-item-icon>
                                    <v-icon :color="item.color">{{item.icon}}</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-subtitle class="mb-2">{{$t('contact.' + item.name)}}</v-list-item-subtitle>
                                    <v-list-item-title style="user-select: text" @touchstart.stop @mouseenter.stop @click.stop>{{item.value}}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>

                    </div>
                </v-col>
            </v-row>
        </e-section>


        <!-- <e-section headline="فريق العمل" subtitle="فريق عمل EBMSoft في الوقت الحالي" light>
            <v-row>
                <v-col v-for="member in teamMembers" cols="4" :key="member.name">
                </v-col>
            </v-row>
        </e-section> -->

        <e-footer />

        <scroll-to-top />
    </div>
</template>

<script>
// @ is an alias to /src
import 'particles.js';
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles

import Countup from '@/components/custom/countup'

import ScrollToTop from '@/components/custom/scroll-to-top'
import ScrollIcon from '@/components/custom/scroll-icon'
import ContactForm from '@/components/custom/contact-form'
// import ColsSection from '@/components/default/cols-section'
import ESection from '@/components/default/e-section'
import Timeline from '@/components/default/timeline'
import EFooter from '@/components/main/e-footer'


import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import axios from 'axios';

export default {
    name: "Home",
    components: {
        ScrollToTop,
        Countup,
        ContactForm,
        Timeline,
        // ColsSection,
        ESection,
        ScrollIcon,
        EFooter
    },
    data(){
        return {
            currentScrollTop: 0,
            
            contactItems: [
                {name: 'email', icon: 'mdi-email', value: 'info@derasa.tech', color: 'primary'},
                {name: 'facebook', icon: 'mdi-facebook', value: 'Derasa Tech', color: 'blue darken-1', href: 'https://facebook.com/derasatech'},
                {name: 'website', icon: 'mdi-web', value: 'www.derasa.tech', color: 'grey', href: 'https://derasa.tech'},
            ],
            projects: [
                {
                    image: '/img/coming-soon.png',
                    title: "EBM Affiliates System",
                    subtitle: "Advanced and Modern E-commerce platform that helps sellers connect with marketers and affiliates people that have the ability to reach buyers easily by their selling channels"
                },
                {
                    image: '/img/coming-soon.png',
                    title: "E-Commerce Platform",
                    subtitle: "E-Commerce Project, we'll publish more info at the right time"
                },
                {
                    image: '/img/coming-soon.png',
                    title: "E-Commerce Project",
                    subtitle: "E-commerce Project that will help merchants and small-to-medium stores to start selling online!"
                },
            ],
            /* teamMembers: [
                {name: 'Ebrahim Maher', job: 'Founder, CEO & Developer', avatar: '/img/team/ebrahim-maher.jpg', description: 'Founder and CEO of EBMSoft company '}
            ], */
        }
    },
    computed: {
        industriesCols(){
            return [
               {color: 'blue', icon: 'mdi-cart-outline', headline: this.$t('sections.industries.cols.0.headline'), description: this.$t('sections.industries.cols.0.description')},
               {color: 'deep-orange', icon: 'mdi-currency-usd-circle-outline', headline: this.$t('sections.industries.cols.1.headline'), description: this.$t('sections.industries.cols.1.description')},
               {color: 'teal', icon: 'mdi-store', headline: this.$t('sections.industries.cols.2.headline'), description: this.$t('sections.industries.cols.2.description')},
            ];
        },
        timeline(){

            return [
                {date: '27-8-2020', title: this.$t('timeline.0.title'), content: this.$t('timeline.0.content')},
                {date: this.$t('timeline.1.date'), title: this.$t('timeline.1.title'), content: this.$t('timeline.1.content')}
            ];
        },
        stats(){
            return this.homeData ? this.homeData.stats : {};
        },
        ...GlobalComputed
    },
    methods: {
        scrollToSection(n){
            let i = n-1,
                element = document.querySelectorAll('.page-sections section')[i];
            if (element){
                this.scrollToElement(element);
            }
        },
        scrollObserver(){
            window.addEventListener('scroll', ()=>{
                this.currentScrollTop = document.documentElement.scrollTop;
            })
        },
        handleScrollChange(scrollTop){
            const sections = document.querySelectorAll('.page-sections section');
            sections.forEach(section => {
                let offsetTop = section.offsetTop - this.navbarHeight, // decrease navbarHeight
                    offsetBottom = offsetTop + section.offsetHeight;

                if (scrollTop >= offsetTop && scrollTop < offsetBottom){
                    let sectionName = section.getAttribute('data-section');
                    if(sectionName){
                        this.$store.commit('SET_ACTIVE_SECTION', sectionName)
                    }
                    // section is visible...
                    if (section.getAttribute('data-theme') === 'light'){
                        
                        if (!this.lightNavbar){
                            this.$store.commit('SET_LIGHT_NAVBAR', true);
                        }
                    }else{
                        if (this.lightNavbar){
                            this.$store.commit('SET_LIGHT_NAVBAR', false);
                        }
                    }
                }
            })

        },
        init(){
            this.scrollObserver();
            AOS.init({container: document.documentElement, once: true, easing: 'ease'});
        },
        ...GlobalMethods
    },
    watch: {
        currentScrollTop(top){
            this.handleScrollChange(top);
        }
    },

    mounted(){
        if (!this.homeData){
            axios.get('/app').then(response=>{
                const homeData = response.data;
                this.$store.commit('SET_HOME_DATA', homeData);
                this.$store.commit('SET_LOADING', false);
                this.init();
            }).catch(e=>{
                // data cannot be loaded! backend is down.
            })
        }
    }
};
</script>
<style lang="scss" scoped>
    .page-sections{
        overflow: hidden;
    }
    section{

        .container{
            z-index: 1;
            display: flex;
            justify-content: center;
            align-items: start;
            flex-direction: column;

            &, *{
                z-index: 1;
            }
        }
        &.header-section{
            background-color: #061228!important;
            color: white;
        }
        h1{
            font-size: 4rem;
            font-weight: 400;

            @media(max-width: 960px){
                text-align: center;
                font-size: 1.7rem;
                line-height: 2.4rem;
                font-weight: 400;
            }
        }
        h2{
            font-size: 2.2rem;
            word-break: break-word!important;
            font-weight: 300;

            @media(max-width: 960px){
                text-align: center;
                font-size: 1.3rem;
                font-weight: 300;
            }
        }
        .actions{
            margin-top: 3rem;
            @media(max-width: 960px){
                margin: 2rem 0;
                width: 100%;
                text-align: center;
                justify-content: center;
            }
            .v-btn{
                @media(min-width: 960px){
                    min-width: 130px;
                    min-height: 45px;
                }
            }
        }
        .section-scroll-icon{
            z-index: 2;
            position: absolute;
            bottom: 8%;
            left: 50%;
            transform: translateX(-50%);
        }
        .clients-items, .partners-items{
            display: flex;
            align-items: center;
            margin: 0 auto;
            overflow-x: auto;
            @media(min-width: 960px){
                justify-content: center;
                flex-wrap: wrap;
                overflow-x: hidden;
            }
        }
        .clients-items{
            @media(min-width: 960px){
                max-width: 900px
            }
        }
        .partners-items{
            @media(min-width: 960px){
                max-width: 1000px
            }
        }
        .client-logo, .partner-logo{
            img{
                user-select: none;
                -webkit-user-drag: none;
                user-drag: none;
                -webkit-touch-callout: none;
            }
        }
        /* .client-logo{
            filter: grayscale(1);
            transition: 0.5s ease all;
            &:hover{
                filter: none;
            }
        } */
    }
</style>